@if (user) {
  <div class="profile_information--content">
    <div class="profile_information--content profile_information--payment">
      <div class="profile_information--add-new-container">
        <button
          type="button"
          (click)="addCard(newCard)"
          [disabled]="!isEditable"
          appButton="small"
          class="profile_information--add-button"
          i18n="@@ProfileInformation-Add-New-Card"
          tabindex="0"
        >
          Add New Card
        </button>
      </div>
      <table>
        <thead class="profile_information--table-thead">
          <tr>
            <th i18n="@@ProfileInformation-id">Id</th>
            <th i18n="@@ProfileInformation-label">Label</th>
            <th i18n="@@ProfileInformation-status">Status</th>
            <th i18n="@@ProfileInformation-expires">Expires</th>
            <th i18n="@@ProfileInformation-Edit">Edit</th>
            <th i18n="@@ProfileInformation-Delete">Delete</th>
          </tr>
        </thead>
        <tbody class="profile_information--table-tbody">
          @if (cards.length > 0) {
            @for (card of cards; track card; let i = $index) {
              <tr>
                <td>{{ card.id }}</td>
                <td>{{ card.label }}</td>
                <td>{{ card.status }}</td>
                <td>{{ card.expires | date: 'dd/MM/yyyy' }}</td>
                <td>
                  <button
                    tabindex="0"
                    [disabled]="!isEditable"
                    [class.disable-button]="!isEditable"
                    class="mat-stroked-button"
                    (click)="editCard(card)"
                  >
                    <span i18n="@@ProfileInformation-Edit">Edit</span>
                  </button>
                </td>
                <td>
                  <button
                    tabindex="0"
                    [disabled]="!isEditable"
                    [class.disable-button]="!isEditable"
                    class="mat-stroked-button"
                    (click)="deleteCard(card.id)"
                  >
                    <span i18n="@@ProfileInformation-Delete">Delete</span>
                  </button>
                </td>
              </tr>
            }
          } @else {
            <tr>
              <td colspan="6" i18n="@@ProfileInformation-NoSavedCards">
                The user has no saved cards for this payment method.
              </td>
            </tr>
          }
        </tbody>
      </table>
      @if (editCardItem) {
        <div [formGroup]="paymentForm">
          <div class="profile_information--input-container">
            <div class="profile_information--input-label">
              <div class="profile_information--asterisk">*</div>
              <span i18n="@@EnterLabelforCard">Enter Label for Card</span>:
            </div>
            <div class="profile_information--input-wrapper">
              <input
                class="profile_information--input"
                tabindex="0"
                formControlName="label"
                aria-label="Label for Card"
              />
              @if (paymentForm.get('label').invalid || paymentForm.get('label').touched) {
                <div>
                  @if (paymentForm.get('label').errors?.required) {
                    <div
                      class="profile_information--error-message"
                      i18n="@@ProfileInformation-label-required"
                    >
                      Label required
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="profile_information--input-container">
            <div class="profile_information--input-label">
              <div class="profile_information--asterisk">*</div>
              <span i18n="@@ProfileInformation-status">Status</span>:
            </div>
            <div class="profile_information--input-wrapper">
              <select
                class="profile_information--input"
                tabindex="0"
                aria-label="Status"
                formControlName="status"
                disabled
              >
                @for (status of ApexxCardStatus | keyvalue; track status) {
                  <option [ngValue]="status.value">
                    {{ status.value | titlecase | translate }}
                  </option>
                }
              </select>
              <fa-icon [icon]="faChevronDown"></fa-icon>
              @if (paymentForm.get('status').invalid || paymentForm.get('status').touched) {
                <div>
                  @if (paymentForm.get('status').errors?.required) {
                    <div
                      class="profile_information--error-message"
                      i18n="@@ProfileInformation-status-required"
                    >
                      Status required
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (editCardItem) {
        <div class="profile_information--add-new-container">
          <button
            type="button"
            tabindex="0"
            (click)="saveCard()"
            [disabled]="!isEditable"
            appButton="small"
            i18n="@@Save"
          >
            Save
          </button>
        </div>
      }
    </div>
  </div>
}
